import { render, staticRenderFns } from "./AroundView.vue?vue&type=template&id=0bc74828"
import script from "./AroundView.vue?vue&type=script&lang=js"
export * from "./AroundView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports